<div class="deviceControl" [attr.data-intro]="'help.devcontrol.all'|translate">

    <div *ngIf="!splitPaneVisible" class="sort" [innerHTML]="listDescription"
         [attr.data-intro]="'help.devcontrol.desc'|translate"></div>

    <ion-range class="compact" pin="true" step="1" min="1" debounce="100"
               [max]="countResults"
               [value]="sliderPos"
               (ionChange)="sliderChange($event)"></ion-range>

    <ion-button fill="clear" size="small"
                [disabled]="!firstEnabled" (click)="first()"
                [attr.data-intro]="'help.devcontrol.first'|translate">
        <ion-icon slot="icon-only" name="play-skip-back-outline"></ion-icon>
    </ion-button>

    <ion-button fill="clear" size="small"
                [disabled]="!skipPrevEnabled" (click)="skipPrev()"
                [attr.data-intro]="'help.devcontrol.skipPrev'|translate">
        <ion-icon slot="icon-only" name="play-back-outline"></ion-icon>
    </ion-button>

    <ion-button fill="clear" size="small"
                [disabled]="!prevEnabled" (click)="prev()"
                [attr.data-intro]="'help.devcontrol.prev'|translate">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
    </ion-button>

    <span class="invnr" [attr.data-intro]="'help.devcontrol.pos'|translate">
        {{sliderPos}} / {{countResults}}
    </span>

    <ion-button fill="clear" size="small"
                [disabled]="!nextEnabled" (click)="next()"
                [attr.data-intro]="'help.devcontrol.next'|translate">
        <ion-icon slot="icon-only" name="arrow-forward"></ion-icon>
    </ion-button>

    <ion-button fill="clear" size="small"
                [disabled]="!skipNextEnabled" (click)="skipNext()"
                [attr.data-intro]="'help.devcontrol.skipNext'|translate">
        <ion-icon slot="icon-only" name="play-forward-outline"></ion-icon>
    </ion-button>

    <ion-button fill="clear" size="small"
                [disabled]="!lastEnabled" (click)="last()"
                [attr.data-intro]="'help.devcontrol.last'|translate">
        <ion-icon slot="icon-only" name="play-skip-forward-outline"></ion-icon>
    </ion-button>

</div>
